import Divider_icon from "../icons/divider";
import React from 'react'
import IconPicker from './icon-picker/index';
import color_palette from '../gb-helper/color_palette';
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
const { registerBlockType, registerBlocksStyle } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar,
    RichText,
    MediaUpload, MediaUploadCheck, InnerBlocks } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, SelectControl, optgroup, RangeControl, Dashicon, ToggleControl, ColorPalette, ColorIndicator,
    Card, CardBody, Button, AlignmentMatrixControl, AnglePickerControl, ColorGradientControl, __experimentalGradientPicker, ColorPicker } = wp.components;
function createSVGElement(returnObj) {
    let item = !!returnObj.path ? 'path' : !!returnObj.polygon ? 'polygon' : !!returnObj.rect ? 'rect' : !!returnObj.g ? 'g' : !!returnObj.polyline ? 'polyline' : null;

    let svg = '%3Csvg ';
    window.lodash.map(returnObj.svgAttrs, (v, k) => {
        svg += `${k}='${v}' `;
    })
    svg += "%3E%3C" + item + " ";

    window.lodash.map(returnObj[item], (v, k) => {
        svg += `${k}='${v}' `;
    })
    svg += "/%3E%3C/svg%3E";
    let styles = {
        background: `url("data:image/svg+xml,${svg}") 0% 0% / 20px 100%`,
        minHeight: '20px',
        backgroundSize: '20px 100%',
        backgroundRrepeat: 'repeat-x',
    };
    return styles;
}

function Divider(props) {
    let svgAttrs = { xmlns: 'http://www.w3.org/2000/svg', stroke: props.stroke, overflow: 'visible', height: '100%', "stroke-width": props.strokewidth, "stroke-linecap": 'square', "stroke-miterlimit": '10' };
    let diviBreak = { richtext: props.text_divider, icon: props.icon_selector, }
    let returnObj = {};

    switch (props.svg) {
        case "None":
            return (
                null
            )
            break;
        case "Solid":
            return (
                <>
                    <div style={{ borderTop: "1px solid", borderTopColor: props.stroke, borderWidth:props.strokewidth }}></div>
                </>
            )
            break;
        case "Double":
            return (
                <>
                    <div style={{ borderTop: "1px double", borderTopColor: props.stroke, borderWidth:props.strokewidth }}></div>
                </>
            )
            break;
        case "Dashed":
            return (
                <>
                    <div style={{ borderTop: "1px dashed", borderTopColor: props.stroke, borderWidth:props.strokewidth }}></div>
                </>
            )
            break;
        case "Dotted":
            return (
                <>
                    <div style={{ borderTop: "1px dotted", borderTopColor: encodeURIComponent(props.stroke), borderWidth:props.strokewidth }}></div>
                </>
            )
            break;
        case "Curly":
            returnObj = { ...diviBreak, path: { d: "M0,21c3.3,0,8.3-0.9,15.7-7.1c6.6-5.4,4.4-9.3,2.4-10.3c-3.4-1.8-7.7,1.3-7.3,8.8C11.2,20,17.1,21,24,21" }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '002424', fill: "none", ...svgAttrs } };
            break;
        case "Curved":
            returnObj = { ...diviBreak, path: { d: "M0,6c6,0,6,13,12,13S18,6,24,6" }, svgAttrs: { viewBox: '002424', fill: "none", ...svgAttrs } };
            break;
        case "Slashes":
            returnObj = { ...diviBreak, path: { d: ['M28,0L10,18', 'M18,0L0,18', 'M48,0L30,18', 'M38,0L20,18'] }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '002016', fill: "none", ...svgAttrs } };
            break;
        case "Squared":
            returnObj = { ...diviBreak, polyline: { points: '0,6 6,6 6,18 18,18 18,6 24,6 ' }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '0 0 24 24', fill: "none", ...svgAttrs } };
            break;
        case "Wavy":
            returnObj = { ...diviBreak, path: { d: 'M0,6c6,0,0.9,11.1,6.9,11.1S18,6,24,6' }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '002424', fill: "none", ...svgAttrs } };
            break;
        case "ZigZag":
            returnObj = { ...diviBreak, polyline: { points: '0,18 12,6 24,18 ' }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '002424', fill: "none", ...svgAttrs } };
            break;
        case "Multiple":
            returnObj = { ...diviBreak, path: { d: 'M24,8v12H0V8H24zM24,4v1H0V4H24z' }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '002424', fill: props.stroke, ...svgAttrs } };
            break;
        case "Arrows":
            returnObj = { ...diviBreak, path: { d: 'M14.2,4c0.3,0,0.5,0.1,0.7,0.3l7.9,7.2c0.2,0.2,0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7l-7.9,7.2c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3s-0.3-0.4-0.3-0.7l0-2.9l-11.5,0c-0.4,0-0.7-0.3-0.7-0.7V9.4C1,9,1.3,8.7,1.7,8.7l11.5,0l0-3.6c0-0.3,0.1-0.5,0.3-0.7S13.9,4,14.2,4z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '002424', fill: props.stroke, ...svgAttrs } };
            break;
        case "Pluses":
            returnObj = { ...diviBreak, path: { d: 'M21.4,9.6h-7.1V2.6c0-0.9-0.7-1.6-1.6-1.6h-1.6c-0.9,0-1.6,0.7-1.6,1.6v7.1H2.6C1.7,9.6,1,10.3,1,11.2v1.6c0,0.9,0.7,1.6,1.6,1.6h7.1v7.1c0,0.9,0.7,1.6,1.6,1.6h1.6c0.9,0,1.6-0.7,1.6-1.6v-7.1h7.1c0.9,0,1.6-0.7,1.6-1.6v-1.6C23,10.3,22.3,9.6,21.4,9.6z' }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '002424', fill: props.stroke, ...svgAttrs } };
            break;
        case "Rhombus":
            returnObj = { ...diviBreak, path: { d: 'M12.7,2.3c-0.4-0.4-1.1-0.4-1.5,0l-8,9.1c-0.3,0.4-0.3,0.9,0,1.2l8,9.1c0.4,0.4,1.1,0.4,1.5,0l8-9.1c0.3-0.4,0.3-0.9,0-1.2L12.7,2.3z' }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '002424', fill: props.stroke, ...svgAttrs } };
            break;
        case "Parallelogram":
            returnObj = { ...diviBreak, polygon: { points: '9.4,2 24,2 14.6,21.6 0,21.6' }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '002424', fill: props.stroke, ...svgAttrs } };
            break;
        case "Rectangles":
            returnObj = { ...diviBreak, rect: { x: '15', y: '0', width: '30', height: '30' }, svgAttrs: { preserveAspectRatio: 'none', viewBox: '0 0 60 30', fill: props.stroke, ...svgAttrs } };
            break;
        case "Dots":
            returnObj = { ...diviBreak, path: { d: 'M3,10.2c2.6,0,2.6,2,2.6,3.2S4.4,16.5,3,16.5s-3-1.4-3-3.2S0.4,10.2,3,10.2zM18.8,10.2c1.7,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2c-1.7,0-3.2-1.4-3.2-3.2S17,10.2,18.8,10.2zM34.6,10.2c1.5,0,2.6,1.4,2.6,3.2s-0.5,3.2-1.9,3.2c-1.5,0-3.4-1.4-3.4-3.2S33.1,10.2,34.6,10.2zM50.5,10.2c1.7,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2c-1.7,0-3.3-0.9-3.3-2.6S48.7,10.2,50.5,10.2zM66.2,10.2c1.5,0,3.4,1.4,3.4,3.2s-1.9,3.2-3.4,3.2c-1.5,0-2.6-0.4-2.6-2.1S64.8,10.2,66.2,10.2zM82.2,10.2c1.7,0.8,2.6,1.4,2.6,3.2s-0.1,3.2-1.6,3.2c-1.5,0-3.7-1.4-3.7-3.2S80.5,9.4,82.2,10.2zM98.6,10.2c1.5,0,2.6,0.4,2.6,2.1s-1.2,4.2-2.6,4.2c-1.5,0-3.7-0.4-3.7-2.1S97.1,10.2,98.6,10.2zM113.4,10.2c1.2,0,2.2,0.9,2.2,3.2s-0.1,3.2-1.3,3.2s-3.1-1.4-3.1-3.2S112.2,10.2,113.4,10.2z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0012626', fill: props.stroke, ...svgAttrs } };
            break;
        case "Firtree":
            returnObj = { ...diviBreak, path: { d: 'M111.9,18.3v3.4H109v-3.4H111.9zM90.8,18.3v3.4H88v-3.4H90.8zM69.8,18.3v3.4h-2.9v-3.4H69.8zM48.8,18.3v3.4h-2.9v-3.4H48.8zM27.7,18.3v3.4h-2.9v-3.4H27.7zM6.7,18.3v3.4H3.8v-3.4H6.7zM46.4,4l4.3,4.8l-1.8,0l3.5,4.4l-2.2-0.1l3,3.3l-11,0.4l3.6-3.8l-2.9-0.1l3.1-4.2l-1.9,0L46.4,4zM111.4,4l2.4,4.8l-1.8,0l3.5,4.4l-2.5-0.1l3.3,3.3h-11l3.1-3.4l-2.5-0.1l3.1-4.2l-1.9,0L111.4,4zM89.9,4l2.9,4.8l-1.9,0l3.2,4.2l-2.5,0l3.5,3.5l-11-0.4l3-3.1l-2.4,0L88,8.8l-1.9,0L89.9,4zM68.6,4l3,4.4l-1.9,0.1l3.4,4.1l-2.7,0.1l3.8,3.7H63.8l2.9-3.6l-2.9,0.1L67,8.7l-2,0.1L68.6,4zM26.5,4l3,4.4l-1.9,0.1l3.7,4.7l-2.5-0.1l3.3,3.3H21l3.1-3.4l-2.5-0.1l3.2-4.3l-2,0.1L26.5,4zM4.9,4l3.7,4.8l-1.5,0l3.1,4.2L7.6,13l3.4,3.4H0l3-3.3l-2.3,0.1l3.5-4.4l-2.3,0L4.9,4z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0012626', fill: props.stroke, ...svgAttrs } };
            break;
        case "Halfrounds":
            returnObj = { ...diviBreak, path: { d: 'M11.9,15.9L11.9,15.9L0,16c-0.2-3.7,1.5-5.7,4.9-6C10,9.6,12.4,14.2,11.9,15.9zM26.9,15.9L26.9,15.9L15,16c0.5-3.7,2.5-5.7,5.9-6C26,9.6,27.4,14.2,26.9,15.9zM37.1,10c3.4,0.3,5.1,2.3,4.9,6H30.1C29.5,14.4,31.9,9.6,37.1,10zM57,15.9L57,15.9L45,16c0-3.4,1.6-5.4,4.9-5.9C54.8,9.3,57.4,14.2,57,15.9zM71.9,15.9L71.9,15.9L60,16c-0.2-3.7,1.5-5.7,4.9-6C70,9.6,72.4,14.2,71.9,15.9zM82.2,10c3.4,0.3,5,2.3,4.8,6H75.3C74,13,77.1,9.6,82.2,10zM101.9,15.9L101.9,15.9L90,16c-0.2-3.7,1.5-5.7,4.9-6C100,9.6,102.4,14.2,101.9,15.9zM112.1,10.1c2.7,0.5,4.3,2.5,4.9,5.9h-11.9l0,0C104.5,14.4,108,9.3,112.1,10.1z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0012026', fill: props.stroke, stroke: props.stroke, ...svgAttrs } };
            break;
        case "Leaves":
            returnObj = { ...diviBreak, path: { d: 'M3,1.5C5,4.9,6,8.8,6,13s-1.7,8.1-5,11.5C0.3,21.1,0,17.2,0,13S1,4.9,3,1.5zM16,1.5c2,3.4,3,7.3,3,11.5s-1,8.1-3,11.5c-2-4.1-3-8.3-3-12.5S14,4.3,16,1.5zM29,1.5c2,4.8,3,9.3,3,13.5s-1,7.4-3,9.5c-2-3.4-3-7.3-3-11.5S27,4.9,29,1.5zM41.1,1.5C43.7,4.9,45,8.8,45,13s-1,8.1-3,11.5c-2-3.4-3-7.3-3-11.5S39.7,4.9,41.1,1.5zM55,1.5c2,2.8,3,6.3,3,10.5s-1.3,8.4-4,12.5c-1.3-3.4-2-7.3-2-11.5S53,4.9,55,1.5zM68,1.5c2,3.4,3,7.3,3,11.5s-0.7,8.1-2,11.5c-2.7-4.8-4-9.3-4-13.5S66,3.6,68,1.5zM82,1.5c1.3,4.8,2,9.3,2,13.5s-1,7.4-3,9.5c-2-3.4-3-7.3-3-11.5S79.3,4.9,82,1.5zM94,1.5c2,3.4,3,7.3,3,11.5s-1.3,8.1-4,11.5c-1.3-1.4-2-4.3-2-8.5S92,6.9,94,1.5zM107,1.5c2,2.1,3,5.3,3,9.5s-0.7,8.7-2,13.5c-2.7-3.4-4-7.3-4-11.5S105,4.9,107,1.5z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0011726', fill: props.stroke, ...svgAttrs } };
            break;
        case "Stripes":
            returnObj = { ...diviBreak, path: { d: 'M54,1.6V26h-9V2.5L54,1.6zM69,1.6v23.3L60,26V1.6H69zM24,1.6v23.5l-9-0.6V1.6H24zM30,0l9,0.7v24.5h-9V0zM9,2.5v22H0V3.7L9,2.5zM75,1.6l9,0.9v22h-9V1.6zM99,2.7v21.7h-9V3.8L99,2.7zM114,3.8v20.7l-9-0.5V3.8L114,3.8z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0012026', fill: props.stroke, ...svgAttrs } };
            break;
        case "Squares":
            returnObj = { ...diviBreak, path: { d: 'M46.8,7.8v11.5L36,18.6V7.8H46.8zM82.4,7.8L84,18.6l-12,0.7L70.4,7.8H82.4zM0,7.8l12,0.9v9.9H1.3L0,7.8zM30,7.8v10.8H19L18,7.8H30zM63.7,7.8L66,18.6H54V9.5L63.7,7.8zM89.8,7L102,7.8v10.8H91.2L89.8,7zM108,7.8l12,0.9v8.9l-12,1V7.8z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0012626', fill: props.stroke, ...svgAttrs } };
            break;
        case "Trees":
            returnObj = { ...diviBreak, path: { d: 'M6.4,2l4.2,5.7H7.7v2.7l3.8,5.2l-3.8,0v7.8H4.8v-7.8H0l4.8-5.2V7.7H1.1L6.4,2zM25.6,2L31,7.7h-3.7v2.7l4.8,5.2h-4.8v7.8h-2.8v-7.8l-3.8,0l3.8-5.2V7.7h-2.9L25.6,2zM47.5,2l4.2,5.7h-3.3v2.7l3.8,5.2l-3.8,0l0.4,7.8h-2.8v-7.8H41l4.8-5.2V7.7h-3.7L47.5,2zM66.2,2l5.4,5.7h-3.7v2.7l4.8,5.2h-4.8v7.8H65v-7.8l-3.8,0l3.8-5.2V7.7h-2.9L66.2,2zM87.4,2l4.8,5.7h-2.9v3.1l3.8,4.8l-3.8,0v7.8h-2.8v-7.8h-4.8l4.8-4.8V7.7h-3.7L87.4,2zM107.3,2l5.4,5.7h-3.7v2.7l4.8,5.2h-4.8v7.8H106v-7.8l-3.8,0l3.8-5.2V7.7h-2.9L107.3,2z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0012326', fill: props.stroke, ...svgAttrs } };
            break;
        case "Tribal":
            returnObj = { ...diviBreak, path: { d: 'M29.6,10.3l2.1,2.2l-3.6,3.3h7v2.9h-7l3.6,3.5l-2.1,1.7l-5.2-5.2h-5.8v-2.9h5.8L29.6,10.3zM70.9,9.6l2.1,1.7l-3.6,3.5h7v2.9h-7l3.6,3.3l-2.1,2.2l-5.2-5.5h-5.8v-2.9h5.8L70.9,9.6zM111.5,9.6l2.1,1.7l-3.6,3.5h7v2.9h-7l3.6,3.3l-2.1,2.2l-5.2-5.5h-5.8v-2.9h5.8L111.5,9.6zM50.2,2.7l2.1,1.7l-3.6,3.5h7v2.9h-7l3.6,3.3l-2.1,2.2L45,10.7h-5.8V7.9H45L50.2,2.7zM11,2l2.1,1.7L9.6,7.2h7V10h-7l3.6,3.3L11,15.5L5.8,10H0V7.2h5.8L11,2zM91.5,2l2.1,2.2l-3.6,3.3h7v2.9h-7l3.6,3.5l-2.1,1.7l-5.2-5.2h-5.8V7.5h5.8L91.5,2z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0012126', fill: props.stroke, ...svgAttrs } };
            break;
        case "X":
            returnObj = { ...diviBreak, path: { d: 'M10.7,6l2.5,2.6l-4,4.3l4,5.4l-2.5,1.9l-4.5-5.2l-3.9,4.2L0.7,17L4,13.1L0,8.6l2.3-1.3l3.9,3.9L10.7,6zM23.9,6.6l4.2,4.5L32,7.2l2.3,1.3l-4,4.5l3.2,3.9L32,19.1l-3.9-3.3l-4.5,4.3l-2.5-1.9l4.4-5.1l-4.2-3.9L23.9,6.6zM73.5,6L76,8.6l-4,4.3l4,5.4l-2.5,1.9l-4.5-5.2l-3.9,4.2L63.5,17l4.1-4.7L63.5,8l2.3-1.3l4.1,3.6L73.5,6zM94,6l2.5,2.6l-4,4.3l4,5.4L94,20.1l-3.9-5l-3.9,4.2L84,17l3.2-3.9L84,8.6l2.3-1.3l3.2,3.9L94,6zM106.9,6l4.5,5.1l3.9-3.9l2.3,1.3l-4,4.5l3.2,3.9l-1.6,2.1l-3.9-4.2l-4.5,5.2l-2.5-1.9l4-5.4l-4-4.3L106.9,6zM53.1,6l2.5,2.6l-4,4.3l4,4.6l-2.5,1.9l-4.5-4.5l-3.5,4.5L43.1,17l3.2-3.9l-4-4.5l2.3-1.3l3.9,3.9L53.1,6z' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '0012626', fill: props.stroke, ...svgAttrs } };
            break;
        case "Zigzagcurve":
            returnObj = { ...diviBreak, polygon: { points: '0,14.40,2111.5,12.421.3,2030.4,11.140.3,2051,12.460.6,2069.6,11.179.3,2090.1,12.499.6,20109.7,11.1120,21120,14.4109.7,599.6,1390.1,579.3,14.571,5.760.6,12.451,540.3,14.531.1,521.3,1311.5,5' }, svgAttrs: { preserveAspectRatio: 'xMidYMidmeet', viewBox: '00 12026', fill: props.stroke, ...svgAttrs } };
            break;
    }

    let svgStyle = createSVGElement(returnObj);
    return (
        <>
            <div style={svgStyle}>

            </div></>);

}

registerBlockType('blocksbakery/divider', {
    title: __('Divider'),
    category: "blocks-bakery",
    icon: Divider_icon.Divider,
    attributes: {
        "sep_style": {
            "type": "string",
            "default": "none"
        },
        "width_per_px": {
            "type": "string",
            "default": "%"
        },
        "seprator_width": {
            "type": "number",
            "default": 100,
        },
        "max_range": {
            "type": "number",
            "default": 100,
        },
        "justify_content": {
            "type": "string",
            "default": "flex-start"
        },
        "bg_pattern": {
            "type": "string",
        },
        "divider_width": {
            "type": "number",
            "default": 1
        },
        "divider_size_width": {
            "type": "number",
            "default": 10
        },
        "seprator_divider_style": {
            "type": "string",
            "default": "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M0,21c3.3,0,8.3-0.9,15.7-7.1c6.6-5.4,4.4-9.3,2.4-10.3c-3.4-1.8-7.7,1.3-7.3,8.8C11.2,20,17.1,21,24,21'/%3E%3C/svg%3E"
        },




        //for Styling the Add Element or Hide and Show

        "element_text_content": {
            "type": "string",
            "default": "none",
        },
        "element_content": {
            "type": "string",
            "default": "none",
        },
        "element_icon_content": {
            "type": "string",
            "default": "none",
        },
        //for icons

        "icon_selector": {
            "type": "string",
        },
        "text_divider": {
            "type": "string",
        },
        "text_divider_headings": {
            "type": "string",
            "default": "p"
        },
        "title_color": {
            "type": 'string',
            "default": "#000000"
        },
        "divider_text_color":{
            "type":"string",
            "default":""
        },
        "title_family":{
            "type":"string",
            "default":"ABeeZee"
        },
        "divider_text_weight": {
            "type": "string",
            "default": "regular",

        },
        "title_font_size":{
            "type":"number",
            "default":15
        },
        
        "title_shadow_blur":{
            "type":"number",
            "default":0,
        }, 
        "text_shadow_horizental":{
            "type":"number",
            "default":0,
        },
        "text_shadow_vertical":{
            "type":"number",
            "default":0,
        },
        "text_shadow_clors":{
            "type":"string",
            "default":"none",
        },  
        "button_box_shadow_hori":{
            "type":"number",
            "default":0
        },
        "button_box_shadow_vert":{
            "type":"number",
            "default":0
        },
        "button_box_shadow_blur":{
            "type":"number",
            "default":0
        },
        "button_box_shadow_spred":{
            "type":"number",
            "default":0
        },
        "button_box_shadow_wrap_color":{
            "type":"string",
            "default":""
        },
        "divider_desc_lh_controller":{
            "type":"string",
            "default":"em"
        },
        "divider_tile_font_style": {
            "type": "string",
            "default": "initial",
        },
        "divider_text_decoration":{
            "type":"string",
            "default":"none",
        },
        
        "adv_button_text_transform":{
            "type":"string",
            "default":"none",
        },
        "divider_line_height_title":{
            "type":"number",
            "default":2
        },
        "divider_letter_spacing":{
            "type":"number",
            "default":0,
        },
        "px_em_vh_vw_title":{
            "type":"string",
            "default":"px"

        },
        "padding_icon_spacing":{
            "type":"number",
            "default":0,
        },
        "divider_icon_size":{
            "type":"number",
            "default":16,
        },
        "rotate_size":{
            "type":"number",
            "default":""
        },

        "divider_icon_inner_spacing":{
            "type":"number",
            "default":"5"  
        },
        "divider_icon_clr":{
            "type":"string",
            "default":"black"
        },
        "divider_icon_bg_color":{
            "type":"string",
            "default":""
        },
        "divider_icon_border_width":{
            "type":"number",
            "default":0,
        },
    
        "options": {
            type: "array",
            default: [
                { label: 'None', value: 'None' },
                { label: 'Solid', value: 'Solid' },
                { label: 'Double ', value: 'Double' },
                { label: 'Dashed', value: 'Dashed' },
                { label: 'Dotted', value: 'Dotted' },
                { label: 'Curly', value: `Curly` },
                { label: 'Curved', value: `Curved` },
                { label: 'Slashes', value: `Slashes` },
                { label: 'Squared', value: `Squared` },
                { label: 'Wavy', value: `Wavy` },
                { label: 'ZigZag', value: `ZigZag` },
                { label: 'Multiple', value: `Multiple` },
                { label: 'Arrows', value: `Arrows` },
                { label: 'Pluses', value: `Pluses` },
                { label: 'Rhombus', value: `Rhombus` },
                { label: 'Parallelogram', value: `Parallelogram` },
                { label: 'Rectangles', value: `Rectangles` },
                { label: 'Dots', value: `Dots` },
                { label: 'Fir Tree', value: `Firtree` },
                { label: 'Half Rounds', value: `Halfrounds` },
                { label: 'Leaves', value: `Leaves` },
                { label: 'Stripes', value: `Stripes` },
                { label: 'Squares', value: `Squares` },
                { label: 'Trees', value: `Trees` },
                { label: 'Tribal', value: `Tribal` },
                { label: 'X', value: `X` },
                { label: 'Zigzag Curve', value: `Zigzagcurve` },
            ]
        },
        "select_option": {
            "type": "string",
            "default": "Curved"
        },
        "divider_content_margin_left":{
            "type":"string",
            "default":"auto"
        },
        "divider_content_margin_right":{
            "type":"string",
            "default":"auto"
        },
        "icon_stracked":{
            "type":"string",
            "default":"dafault"
        },
        

        "divider_border_radius":{
            "type":"number",
            "default":"0"
        },
     
        "divider_border_radius_px_per":{
            "type":"string",
            "default":"px"
        },
     
            
        
       
    },

    edit: function (props) {
        let styles = {
            bb_spacer_wrapper: {
                display: "flex",
                justifyContent: props.attributes.justify_content,
            },
            bb_spacer_text: {
                marginTop: '-20px',
                marginLeft:props.attributes.divider_content_margin_left,
                marginRight: props.attributes.divider_content_margin_right,
                background: 'white',
                width: 'fit-content',
                display:"flex",
                color:props.attributes.divider_text_color,
                fontFamily:props.attributes.title_family,
                fontWeight:props.attributes.divider_text_weight,
                fontSize:props.attributes.title_font_size+props.attributes.px_em_vh_vw_title,
                textShadow: props.attributes.text_shadow_horizental + 'px' + ' ' + props.attributes.text_shadow_vertical + 'px' + ' ' + props.attributes.title_shadow_blur + 'px' + ' ' + props.attributes.text_shadow_clors,
                boxShadow: props.attributes.button_box_shadow_hori + 'px' + ' ' + props.attributes.button_box_shadow_vert + 'px' + ' ' + props.attributes.button_box_shadow_blur + 'px' + ' ' + props.attributes.button_box_shadow_spred+ 'px' + ' ' + props.attributes.button_box_shadow_wrap_color,
                textTransform:props.attributes.adv_button_text_transform,
                fontStyle:props.attributes.divider_tile_font_style,
                textDecoration:props.attributes.divider_text_decoration,
                lineHeight:props.attributes.divider_line_height_title+props.attributes.divider_desc_lh_controller,
                letterSpacing:props.attributes.divider_letter_spacing,
                paddingLeft:props.attributes.padding_icon_spacing+"px",
                paddingRight:props.attributes.padding_icon_spacing+"px",
            },
            bb_spacer_icon: {
                marginTop: '-45px',
                marginLeft:props.attributes.divider_content_margin_left,
                marginRight: props.attributes.divider_content_margin_right,
                background: 'white',
                width: 'fit-content',
                display:"flex",
                fontSize:props.attributes.divider_icon_size+"px",
                color:props.attributes.divider_icon_clr,
                borderColor:props.attributes.divider_icon_clr,
                backgroundColor:props.attributes.divider_icon_bg_color,
                padding:props.attributes.divider_icon_inner_spacing+"px",
                transform:"rotate("+props.attributes.rotate_size+"deg)",
                borderRadius:props.attributes.divider_border_radius+props.attributes.divider_border_radius_px_per,
                borderWidth:props.attributes.divider_icon_border_width,
                borderStyle:"solid",
            },
            bb_spacer: {
                width: props.attributes.seprator_width + props.attributes.width_per_px,
                paddingTop:props.attributes.divider_size_width,
                paddingBottom:props.attributes.divider_size_width
            },
        }
        const seprator_width_per = () => {
            var x = document.querySelector('.seprator_width_per');
            var y = document.querySelector('.seprator_width_px');
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none"
            props.setAttributes({ width_per_px: '%' })
            props.setAttributes({ max_range: 100 })
        }

        const seprator_width_px = () => {
            var x = document.querySelector('.seprator_width_per');
            var y = document.querySelector('.seprator_width_px');
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline"
            props.setAttributes({ width_per_px: 'px' })
            props.setAttributes({ max_range: 1000 })
        }
        const alignCenter = () => {
            props.setAttributes({ justify_content: 'center' })
        }
        const alignLeft = () => {
            props.setAttributes({ justify_content: 'flex-start' })
        }
        const alignRight = () => {
            props.setAttributes({ justify_content: 'flex-end' })
        }

        const element_none = () => {
            props.setAttributes({ element_content: 'none' })
            props.setAttributes({text_divider:null})
            props.setAttributes({icon_selector:null})
        }
        const element_text = () => {
            props.setAttributes({ element_content: 'block' })
            props.setAttributes({ element_text_content: 'block' })
            props.setAttributes({ element_icon_content: 'none' })
            props.setAttributes({text_divider:props.attributes.text_divider})
            props.setAttributes({icon_selector:null})
        }
        const element_icon = () => {
            props.setAttributes({ element_content: 'block' })
            props.setAttributes({ element_text_content: 'none' })
            props.setAttributes({ element_icon_content: 'block' })
            props.setAttributes({text_divider:null})
            props.setAttributes({icon_selector:props.attributes.icon_selector})
        }
        
        const show_remove_text_properties = () =>{
            var x = document.getElementById("card_data_btn");
            if(x.style.display==="none"){
                x.style.display="block";
            }
            else if(x.style.display==="block"){
                x.style.display="none"
            }
        }

            //functions for font sizes
        
            const px_case = () => {
                var px_case = document.getElementById("px_case");
                var em_case = document.getElementById("em_case");
                var rem_case = document.getElementById("rem_case");
                var vw_case = document.getElementById("vw_case");
                px_case.style.textDecoration = "underline";
                em_case.style.textDecoration = "none";
                rem_case.style.textDecoration = "none";
                vw_case.style.textDecoration = "none";
    
                props.setAttributes({ px_em_vh_vw_title: 'px', font_controller: 200 })
                console.log("px")
            }
            const em_case = () => {
                var px_case = document.getElementById("px_case");
                var em_case = document.getElementById("em_case");
                var rem_case = document.getElementById("rem_case");
                var vw_case = document.getElementById("vw_case");
                px_case.style.textDecoration = "none";
                em_case.style.textDecoration = "underline";
                rem_case.style.textDecoration = "none";
                vw_case.style.textDecoration = "none";
    
                props.setAttributes({ px_em_vh_vw_title: 'em', font_controller: 10 })
                console.log("em")
            }
            const rem_case = () => {
                var px_case = document.getElementById("px_case");
                var em_case = document.getElementById("em_case");
                var rem_case = document.getElementById("rem_case");
                var vw_case = document.getElementById("vw_case");
                px_case.style.textDecoration = "none";
                em_case.style.textDecoration = "none";
                rem_case.style.textDecoration = "underline";
                vw_case.style.textDecoration = "none";
    
                props.setAttributes({ px_em_vh_vw_title: 'rem', font_controller: 10 })
            }
            const vw_case = () => {
                var px_case = document.getElementById("px_case");
                var em_case = document.getElementById("em_case");
                var rem_case = document.getElementById("rem_case");
                var vw_case = document.getElementById("vw_case");
                px_case.style.textDecoration = "none";
                em_case.style.textDecoration = "none";
                rem_case.style.textDecoration = "none";
                vw_case.style.textDecoration = "underline";
    
                props.setAttributes({ px_em_vh_vw_title: 'vw', font_controller: 10 })
            }

              //For Responsive Devices

        const laptop = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
        }
        const tablet = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
        }
        const smartphone = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
        }

        const title_px = () => {
            var x = document.getElementById("title_px");
            var y = document.getElementById("title_em");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({divider_desc_lh_controller:"px"})

        }
        const title_em = () => {
            var x = document.getElementById("title_px");
            var y = document.getElementById("title_em");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({divider_desc_lh_controller:"em"})
        }

        const border_px = () => {
            var x = document.getElementById("border_px");
            var y = document.getElementById("border_per");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({divider_border_radius_px_per:"px"})

        }
        const border_per = () => {
            var x = document.getElementById("border_px");
            var y = document.getElementById("border_per");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({divider_border_radius_px_per:"%"})
        }

        const icon_framed_stracked = (new_val) =>{
            if(new_val==="default"){
                var x = document.querySelector("#strch");
                var y = document.querySelector("#framed");
                props.setAttributes({divider_icon_border_width:0})
                x.style.display="none"
                y.style.display="none"
                console.log("hello")
            }
            else if(new_val==="stacked")
            {
                var x = document.querySelector("#strch");
                var y = document.querySelector("#framed");
                props.setAttributes({divider_icon_bg_color:"#54595F"})
                props.setAttributes({divider_icon_clr:"#FFFFFF"})
                x.style.display="block"
                y.style.display="none"
                console.log("stacked")
            }
            else if(new_val==="framed")
            {
                var x = document.querySelector("#strch");
                var y = document.querySelector("#framed");
                props.setAttributes({divider_icon_bg_color:"transparent"})
                props.setAttributes({divider_icon_clr:"#000000"})
                props.setAttributes({divider_icon_border_width:1})
                x.style.display="block"
                y.style.display="block"
                console.log("framed")
            }
        }
    const alignLeftContent = () => {
    props.setAttributes({divider_content_margin_left:"0"})
    props.setAttributes({divider_content_margin_right:"auto"})
    }
    const alignCenterContent = () => {
        props.setAttributes({divider_content_margin_left:"auto"})
        props.setAttributes({divider_content_margin_right:"auto"})
    }
    const alignRightContent = () => {
        props.setAttributes({divider_content_margin_left:"auto"})
        props.setAttributes({divider_content_margin_right:"0"})
    }
        return [<React.Fragment>
            <InspectorControls>
                <PanelBody title={__("Divider")} initialOpen={false}>
                    <SelectControl
                        label="Style"
                        value={props.attributes.select_option}
                        options={props.attributes.options} onChange={function (e) {
                            props.setAttributes({ select_option: e });
                        }} />

                    <PanelRow>
                        <p>Container Width</p>
                        <div>
                            <Button className="seprator_width_per" onClick={seprator_width_per} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>%</Button>
                            <Button className="seprator_width_px" onClick={seprator_width_px} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                        </div>
                    </PanelRow>

                    <RangeControl
                        min={0}
                        max={props.attributes.max_range}
                        step={0.1}
                        initialPosition={100}
                        value={props.attributes.seprator_width}
                        onChange={(new_val) => {
                            props.setAttributes({ seprator_width: new_val })
                        }}
                    />


                    

                    {/* For alignment  */}

                    <PanelRow>
                        <div><p>Alingment</p></div>
                        <div>
                            <Dashicon style={{ cursor: 'pointer' }} onClick={alignLeft} icon='editor-alignleft' />
                            <Dashicon style={{ cursor: 'pointer' }} onClick={alignCenter} icon='editor-aligncenter' />
                            <Dashicon style={{ cursor: 'pointer' }} onClick={alignRight} icon='editor-alignright' />
                        </div>
                    </PanelRow>

                    <hr />
                    {/* end of alignment  */}

                    {/* Add element  */}
                    <PanelRow>
                        <div><p>Add Element</p></div>
                        <div style={{display:"flex"}}>
                            <Button style={{ border: "1px solid black", padding: "7px 9px", height: "29px" }} onClick={element_none}><i class="eicon-ban" aria-hidden="true"></i></Button>
                            <Button style={{ border: "1px solid black", padding: "7px 9px", height: "29px" }} onClick={element_text}><i class="eicon-t-letter-bold" aria-hidden="true"></i></Button>
                            <Button style={{ border: "1px solid black", padding: "7px 9px", height: "29px" }} onClick={element_icon}><span className={props.attributes.icon_selector}></span></Button>
                        </div>
                    </PanelRow>
                    <br />
                    <div className="bb_element_text" style={{ display: props.attributes.element_content }}>
                        <div className="bb_element_text" style={{ display: props.attributes.element_text_content }}>
                            <PanelRow>
                                <div><p>Text</p></div>
                                <div>
                                    <TextControl
                                        value={props.attributes.text_divider}
                                        onChange={(new_val) => {
                                            props.setAttributes({ text_divider: new_val })
                                        }}
                                    />

                                </div>
                            </PanelRow>
                            <PanelRow>
                                <div><p>Html Tag</p></div>
                                <div>
                                    <SelectControl
                                        options={[
                                            { label: 'H1', value: 'h1' },
                                            { label: 'H2', value: 'h2' },
                                            { label: 'H3', value: 'h3' },
                                            { label: 'H4', value: 'h4' },
                                            { label: 'H5', value: 'h5' },
                                            { label: 'H6', value: 'h6' },
                                            { label: 'div', value: 'div' },
                                            { label: 'span', value: 'span' },
                                            { label: 'p', value: 'p' },
                                        ]}
                                        value={props.attributes.text_divider_headings}
                                        onChange={(new_val) => {
                                            props.setAttributes({ text_divider_headings: new_val })
                                        }}
                                    />
                                </div>
                            </PanelRow>
                        </div>
                        <div className="bb_element_text" style={{ display: props.attributes.element_icon_content }}>
                            <IconPicker
                                allowReset={false}
                                value={props.attributes.icon_selector}
                                onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                            />
                        </div>
                    </div>
                </PanelBody>


                <PanelBody title={__("Style")} initialOpen={false}>

                    <ColorPalette
                        colors={color_palette}
                        clearable={false}
                        onChange={(new_val) => {
                            props.setAttributes({ title_color: new_val })
                        }}
                        value={props.attributes.title_color}
                    />
                    {/* Divider width  */}

                    <RangeControl
                        label="Weight"
                        min={1}
                        max={10}
                        step={0.1}
                        initialPosition={1}
                        value={props.attributes.divider_width}
                        onChange={(new_val) => {
                            props.setAttributes({ divider_width: new_val })
                        }}
                    />


                    {/* End of the divider width  */}


                    {/* Divider Width Style */}

                    <RangeControl
                        label="Gap"
                        min={2}
                        max={50}
                        step={1}
                        initialPosition={10}
                        value={props.attributes.divider_size_width}
                        onChange={(new_val) => {
                            props.setAttributes({ divider_size_width: new_val })
                        }}
                    />

                    <PanelBody title={__("Text")} initialOpen={false}>

                    <ColorPalette
                        colors={color_palette}
                        clearable={false}
                        onChange={(new_val) => {
                            props.setAttributes({ divider_text_color: new_val })
                        }}
                        value={props.attributes.divider_text_color}
                    />
                       <div style={{ display: "flex", alignItems: "center",marginTop:"12px" }}>

                            {/* Typography  */}
                            <div style={{ width: "68%",fontWeight:"14px",marginTop:"-5px",fontWeight:"bold" }}>Typography</div>

                            <div style={{ width: "40%" }}>

                                <Button style={{"border":"1px solid","width":"40px","height":"30px","textAlign":"center","margin":"0px","lineHeight":"10px"}}><i class="fas fa-globe"></i></Button>
                                <Button style={{"border":"1px solid","width":"40px","height":"30px","textAlign":"center","margin":"0px","lineHeight":"10px"}} onClick={show_remove_text_properties}><i class="fas fa-pencil-alt"></i></Button>


                            </div>
                        </div>
                        <Card id="card_data_btn" style={{"marginTop":"9px","boxShadow":"0 2px 15px rgb(0 0 0 / 30%)","display":"none"}}>
                            <CardBody style={{"padding":"16px 8px"}} >

                      
                        <div style={{ display: "flex", alignItems: "center" }}>

                            {/* Typography  */}
                            <div style={{ width: "70%" }}>Family</div>

                            <div style={{ width: "30%" }}>
                                <SelectControl

                                    options={all_font_families}
                                    onChange={(new_val) => {
                                        props.setAttributes({ title_family: new_val })
                                    }}
                                    value={props.attributes.title_family}

                                />
                            </div>
                        </div>


                                    {/* fontsize  */}

                                    <PanelRow>
                            <p>Typography</p>

                            <div>
                                <Button id="px_case" onClick={px_case} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="em_case" onClick={em_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                                <Button id="rem_case" onClick={rem_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>rem</Button>
                                <Button id="vw_case" onClick={vw_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vw</Button>
                            </div>
                        </PanelRow>


                      
                        <RangeControl
                        label="Font Size"
                            min={0}
                            max={200}
                            value={props.attributes.title_font_size}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ title_font_size: new_val })
                             
                            }}
                        />


                                    {/* end of fontsize  */}

                                    {/* start typography etc  */}


                                    <SelectControl
                            label="Text Transform"
                            options={[
                                { label: 'default', value: 'none' },
                                { label: 'Uppercase', value: 'uppercase' },
                                { label: 'Lowercase', value: 'lowercase' },
                                { label: 'Capitlized', value: 'capitalize' },
                                { label: 'Normal', value: 'normal' },

                            ]}
                            value={props.attributes.adv_button_text_transform}
                            onChange={(new_val) => {
                                props.setAttributes({ adv_button_text_transform: new_val })
                            }}
                        />
                        <SelectControl
                            label="Style"
                            options={[
                                { label: 'Default', value: 'initial' },
                                { label: 'Normal', value: 'normal' },
                                { label: 'Italic', value: 'italic' },
                                { label: 'Capitlized', value: 'capitalize' },
                                { label: 'Oblique', value: 'oblique' },

                            ]}
                            value={props.attributes.divider_tile_font_style}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_tile_font_style: new_val })
                            }}
                        />



                        <SelectControl
                            label="Decoration"
                            options={[
                                { label: 'Default', value: 'none' },
                                { label: 'Underline', value: 'underline' },
                                { label: 'line Through', value: 'line-through' },
                                { label: 'Line Trough and Underline', value: 'underline line-through' },
                                { label: 'overline', value: 'overline' },


                            ]}
                            value={props.attributes.divider_text_decoration}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_text_decoration: new_val })
                            }}
                        />


                                    {/* End  */}

                       <div style={{ display: "flex", alignItems: "center" }}>

                            {/* Typography  */}
                            <div style={{ width: "70%" }}>Weight</div>

                            <div style={{ width: "30%" }}>
                             <SelectControl
                        
                                options={
                                    [
                                        { label: '100', value: 100 },
                                        { label: '200', value: 200 },
                                        { label: '300', value: 300 },
                                        { label: '400', value: 400 },
                                        { label: '500', value: 500 },
                                        { label: '600', value: 600 },
                                        { label: '700', value: 700 },
                                        { label: '800', value: 800 },
                                        { label: '900', value: 900 },
                                        { label: 'Default', value: '' },
                                        { label: 'Normal', value: 'normal' },
                                        { label: 'Bold', value: 'bold' }
                                    ]
                                }
                                onChange={(new_val) => {
                                    props.setAttributes({ divider_text_weight: new_val })
                                }}
                                value={props.attributes.divider_text_weight}
                            />

                            </div>
                            </div>

                            {/* For Line Height  */}
                            <div style={{ display: 'flex', justifyContent: 'space-between',alignItems:"center" }}>
                          
                            <div>
                            <span style={{marginRight:"10px"}}>Line Height</span>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        
                            <div>
                                <Button id="title_px" onClick={title_px} style={{  padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="title_em" onClick={title_em} style={{ textDecoration: "underline",padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                            </div>
                            </div>

                            
                            {/* Text Shadow */}
                        




                            {/* Letter Spacing  */}

                            <RangeControl
               
                            min={0}
                            max={100}
                            step={1}
                            initialPosition={2}
                            value={props.attributes.divider_line_height_title}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_line_height_title: new_val })
                            }}
                        />

                           <RangeControl
                            label="Letter Spacing"
                            min={-5}
                            max={10}
                            step={1}
                            initialPosition={0}
                            value={props.attributes.divider_letter_spacing}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_letter_spacing: new_val })
                                
                            }}
                        />
                        </CardBody>
                        </Card>


                        

           
                        <PanelRow>
                            <div><p>Alingment</p></div>
                            <div>
                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignLeftContent} icon='editor-alignleft' />
                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignCenterContent} icon='editor-aligncenter' />
                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignRightContent} icon='editor-alignright' />
                            </div>
                       </PanelRow>

                    </PanelBody>

                    <PanelBody title={__("Icon")} initialOpen={false} >
                    <div style={{ display: "flex", alignItems: "center"}}>
                            <div style={{ width: "30%",marginTop:"-9px",fontWeight:"500" }}>View</div>

                            <div style={{ width: "70%" }}>


                                <SelectControl
                                    options={[
                                        { label: 'Default', value: 'default' },
                                        { label: 'Stacked', value: 'stacked' },
                                        { label: 'framed', value: 'framed' },
                                    

                                    ]}
                                    value={props.attributes.icon_stracked}
                                    onChange={(new_val) => {
                                        props.setAttributes({ icon_stracked: new_val })
                                        icon_framed_stracked(new_val)
                                    
                                    }}

                                />
                            </div>
                        </div>
                        <br/>
<br/>

                        <div className="divider_stracked" >
                        <RangeControl
                        label="Icon Size"
                            min={0}
                            max={300}
                            value={props.attributes.divider_icon_size}
                            initialPosition={16}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_icon_size: new_val })
                            
                            }}
                        />
                        
                           
                 
                          <RangeControl
                            label="Spacing"
                            min={0}
                            max={100}
                            value={props.attributes.padding_icon_spacing}
                            initialPosition={5}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ padding_icon_spacing: new_val })
                            
                            }}
                        />
                        
                      <PanelRow>
                            <div><p>Alingment</p></div>
                            <div>
                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignLeftContent} icon='editor-alignleft' />
                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignCenterContent} icon='editor-aligncenter' />
                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignRightContent} icon='editor-alignright' />
                            </div>
                       </PanelRow>
                   

                   <p>Primary Color</p>
                    <ColorPalette

                        colors={color_palette}
                        clearable={false}
                        onChange={(new_val) => {
                            props.setAttributes({ divider_icon_clr: new_val })
                        }}
                        value={props.attributes.divider_icon_clr}
                    />
                        <div id="strch" style={{display:"none"}}>
                        <p>Secondory Color</p>
                        <ColorPalette
               
                        colors={color_palette}
                        clearable={false}
                        onChange={(new_val) => {
                            props.setAttributes({ divider_icon_bg_color: new_val })
                        }}
                        value={props.attributes.divider_icon_bg_color}
                       />
                       </div>

                        
                  
                  
                            <RangeControl
                        label="Rotate"
                        min={0}
                        max={360}
                        value={props.attributes.rotate_size}
                        initialPosition={5}
                        step={1}
                        onChange={(new_val) => {
                            props.setAttributes({ rotate_size: new_val })
                        
                        }}
                    />
                        <RangeControl
                            label="Padding"
                            min={0}
                            max={100}
                            value={props.attributes.divider_icon_inner_spacing}
                            initialPosition={5}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_icon_inner_spacing: new_val })
                            
                            }}
                        />

                    <div >
                      <div  style={{ display: 'flex', justifyContent: 'space-between',alignItems:"center"}}>
                          
                          <div>
                          <span style={{marginRight:"10px"}}>Border Radius</span>
                              <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                              <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                              <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                          </div>
                      
                          <div>
                              <Button id="border_px" onClick={border_px} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                              <Button id="border_per" onClick={border_per} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>%</Button>
                          </div>
                          </div>  
                          
                          
                             <RangeControl
                           label="Border radius"
                            min={0}
                            max={100}
                            value={props.attributes.divider_border_radius}
                            initialPosition={16}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_border_radius: new_val })
                       
                            }}
                        />
                        </div>
                        <div id="framed" style={{display:"none"}}>


                         <RangeControl
                            label="Border Width"
                            min={0}
                            max={100}
                            value={props.attributes.divider_icon_border_width}
                            initialPosition={0}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_icon_border_width: new_val })
                       
                            }}
                        />
                        </div>

                  
                            </div>

                     


                         
                    
                         <br/> 
                        <br/>
                

                    <br/><br/>
              
                

                        </PanelBody>
                    {/* End of the divider width  */}

               


                </PanelBody>
            </InspectorControls>
            {/* <div style={{background:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M0,21c3.3,0,8.3-0.9,15.7-7.1c6.6-5.4,4.4-9.3,2.4-10.3c-3.4-1.8-7.7,1.3-7.3,8.8C11.2,20,17.1,21,24,21'/%3E%3C/svg%3E")`}}>
            hello
            </div> */}
            <div style={styles.bb_spacer_wrapper}>
            <div style={styles.bb_spacer}>
                <Divider stroke={encodeURIComponent(props.attributes.title_color)} svg={props.attributes.select_option} strokewidth={props.attributes.divider_width}
                // width: props.attributes.seprator_width + props.attributes.width_per_px,
                // minHheight: '20px',
                // backgroundSize: '20px 100%',
                // backgroundRrepeat: 'repeat-x',
                // // backgroundImage: props.attributes.seprator_divider_style,
                // display: 'flex',
                // justifyContent: "center"}}
                />
                <RichText
                    tagName={props.attributes.text_divider_headings}
                    value={props.attributes.text_divider}
                    onChange={(new_val) => {
                        props.setAttributes({ text_divider: new_val })
                    }}
                    style={styles.bb_spacer_text}
                />
                <span style={styles.bb_spacer_icon} className={props.attributes.icon_selector+" bb_div_icon"}></span>
            </div>
            </div>
        </React.Fragment>]
    }

});

// registerBlockType('blocksbakery/divider', {
//     title: __('Divider', 'blocks-bakery'),
//     description: __(
//         'This block is Adding Divider',
//         'blocks-bakery'
//     ),

//     // common, formatting, layout, widgets, embed
//     category: 'blocks-bakery',
//     icon: Divider_icon.Divider,
//     keywords: [
//         __('divider', 'blocks-bakery'),
//         __('border', 'blocks-bakery'),
//         __('seprator', 'blocks-bakery'),
//     ],
//     supports: {
//         html: false
//     },
//     "attributes": {
//         "sep_style": {
//             "type": "string",
//             "default": "none"
//         },
//         "width_per_px": {
//             "type": "string",
//             "default": "%"
//         },
//         "seprator_width": {
//             "type": "number",
//             "default": "100",
//         },
//         "max_range": {
//             "type": "number",
//             "default": "100",
//         },
//         "justify_content": {
//             "type": "string",
//             "default": "flex-start"
//         },
//         "bg_pattern": {
//             "type": "string",
//         },
//         "divider_width": {
//             "type": "number",
//             "default": "2.2"
//         },
//         "divider_size_width": {
//             "type": "number",
//             "default": "1"
//         },
//         "seprator_divider_style": {
//             "type": "string",
//             "default": "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M0,21c3.3,0,8.3-0.9,15.7-7.1c6.6-5.4,4.4-9.3,2.4-10.3c-3.4-1.8-7.7,1.3-7.3,8.8C11.2,20,17.1,21,24,21'/%3E%3C/svg%3E"
//         },




//         //for Styling the Add Element or Hide and Show

//         "element_text_content": {
//             "type": "string",
//             "default": "none",
//         },
//         "element_content": {
//             "type": "string",
//             "default": "none",
//         },
//         "element_icon_content": {
//             "type": "string",
//             "default": "none",
//         },
//         //for icons

//         "icon_selector": {
//             "type": "string",
//             "default": "eicon-star"
//         },
//         "text_divider": {
//             "type": "string",
//             "default": "divider"
//         },
//         "text_divider_headings": {
//             "type": "string",
//             "default": "p"
//         },


//     },


//     edit: (props) => {

//         // var curly = `url("${"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='8' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M0,6c6,0,6,13,12,13S18,6,24,6'/%3E%3C/svg%3E"}")`

//         // console.log(`url("${"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='8' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M0,6c6,0,6,13,12,13S18,6,24,6'/%3E%3C/svg%3E"}")`
//         // )
//         var ReactStyle = { "--divider-border-width": props.attributes.seprator_width };
//         let styles = {
//             ...ReactStyle,
//             bb_spacer_wrapper: {
//                 display: "flex",
//                 justifyContent: props.attributes.justify_content,

//             },
//             bb_spacer_container: {
//                 backgroundColor: 'white',
//                 width: 'fit-content'
//             },
//             bb_spacer: {

//                 width: props.attributes.seprator_width + props.attributes.width_per_px,
//                 minHheight: '20px',
//                 backgroundSize: '20px 100%',
//                 backgroundRrepeat: 'repeat-x',
//                 backgroundImage: props.attributes.seprator_divider_style,
//                 display: 'flex',
//                 justifyContent: "center"
//             },
//             //     bb_spacer_element: {
//             //         display: "flex",
//             //         justifyContent: props.attributes.justify_content
//             //     },
//             //     bb_spacer_divider_wrapper: {
//             //         width: "100%",
//             //         justifyContent: "center",
//             //         display: "flex",
//             //         marginTop: "-18px",
//             //     },
//             //     bb_spacer_element_text: {
//             //         padding: "1px 3px",
//             //         color: "black",
//             //         background: "white",
//             //     }

//         }


//         const seperator_divider_1 = () => {
//             // document.documentElement.style.setProperty('--divider-pattern-url',props.attributes.seprator_divider_style);
//             var bodyStyles = document.body.style;
//             bodyStyles.setProperty('--divider-pattern-url', props.attributes.seprator_divider_style);
//             // bodyStyles.setProperty('--background-color', 'black');
//             // document.documentElement.style.setProperty('--divider-pattern-url',props.attributes.seprator_divider_style);
//             // getComputedStyle(document.documentElement).getPropertyValue('--divider-pattern-url',props.attributes.seprator_divider_style)
//             // document.documentElement.style.getPropertyValue("--divider-pattern-url",props.attributes.seprator_divider_style)
//             // console.log("Hello and welcome")
//         }
//         const seperator_width_scss = () => {
//             document.documentElement.style.setProperty('--divider-border-width', props.attributes.seprator_width + props.attributes.width_per_px);
//         }

//         const seprator_width_per = () => {
//             var x = document.querySelector('.seprator_width_per');
//             var y = document.querySelector('.seprator_width_px');
//             x.style.textDecoration = "underline";
//             y.style.textDecoration = "none"
//             props.setAttributes({ width_per_px: '%' })
//             props.setAttributes({ max_range: 100 })
//         }

//         const seprator_width_px = () => {
//             var x = document.querySelector('.seprator_width_per');
//             var y = document.querySelector('.seprator_width_px');
//             x.style.textDecoration = "none";
//             y.style.textDecoration = "underline"
//             props.setAttributes({ width_per_px: 'px' })
//             props.setAttributes({ max_range: 1000 })
//         }
//         const alignCenter = () => {
      

//         const element_none = () => {
//             props.setAttributes({ element_content: 'none' })
//         }
//         const element_text = () => {
//             props.setAttributes({ element_content: 'block' })
//             props.setAttributes({ element_text_content: 'block' })
//             props.setAttributes({ element_icon_content: 'none' })
//         }
//         const element_icon = () => {
//             props.setAttributes({ element_content: 'block' })
//             props.setAttributes({ element_text_content: 'none' })
//             props.setAttributes({ element_icon_content: 'block' })
//         }


//         return [



//             <React.Fragment>
//                 <InspectorControls>
//                     <PanelBody title={__("Divider")} initialOpen={false}>

//                         {/* <SelectControl

//               label="Style"

//               options={[
//                   { label: 'None', value: 'None' },
//                   { label: 'Solid', value: 'solid' },
//                   { label: 'Double ', value: 'double' },
//                   { label: 'Dashed', value: 'dashed' },
//                   { label: 'Dotted', value: 'dotted' },
//                     ]}

//               onChange={(new_val) => {
//                   props.setAttributes({ seprator_normal_style: new_val })

//               }}
//               value={props.attributes.seprator_normal_style}
//           /> */}

//                         <SelectControl
//                             label="Style"
//                             options={[
//                                 // { label: 'None', value: 'none' },
//                                 // { label: 'Solid', value: 'solid' },
//                                 // { label: 'Double ', value: 'double' },
//                                 // { label: 'Dashed', value: 'dashed' },
//                                 // { label: 'Dotted', value: 'dotted' },
//                                 { label: 'Curly', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M0,21c3.3,0,8.3-0.9,15.7-7.1c6.6-5.4,4.4-9.3,2.4-10.3c-3.4-1.8-7.7,1.3-7.3,8.8C11.2,20,17.1,21,24,21'/%3E%3C/svg%3E")` },
//                                 { label: 'Curved', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M0,6c6,0,6,13,12,13S18,6,24,6'/%3E%3C/svg%3E")` },
//                                 { label: 'Slashes', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 20 16' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cg transform='translate(-12.000000, 0)'%3E%3Cpath d='M28,0L10,18'/%3E%3Cpath d='M18,0L0,18'/%3E%3Cpath d='M48,0L30,18'/%3E%3Cpath d='M38,0L20,18'/%3E%3C/g%3E%3C/svg%3E")` },
//                                 { label: 'Squared', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpolyline points='0,6 6,6 6,18 18,18 18,6 24,6 	'/%3E%3C/svg%3E")` },
//                                 { label: 'Wavy', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpath d='M0,6c6,0,0.9,11.1,6.9,11.1S18,6,24,6'/%3E%3C/svg%3E")` },
//                                 { label: 'ZigZag', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='square' stroke-miterlimit='10'%3E%3Cpolyline points='0,18 12,6 24,18 '/%3E%3C/svg%3E")` },
//                                 { label: 'Multiple', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='black' stroke='none'%3E%3Cpath d='M24,8v12H0V8H24z M24,4v1H0V4H24z'/%3E%3C/svg%3E")` },
//                                 { label: 'Arrows', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 24 24' fill='black' stroke='none'%3E%3Cpath d='M14.2,4c0.3,0,0.5,0.1,0.7,0.3l7.9,7.2c0.2,0.2,0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7l-7.9,7.2c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3s-0.3-0.4-0.3-0.7l0-2.9l-11.5,0c-0.4,0-0.7-0.3-0.7-0.7V9.4C1,9,1.3,8.7,1.7,8.7l11.5,0l0-3.6c0-0.3,0.1-0.5,0.3-0.7S13.9,4,14.2,4z'/%3E%3C/svg%3E")` },
//                                 { label: 'Pluses', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 24 24' fill='black' stroke='none'%3E%3Cpath d='M21.4,9.6h-7.1V2.6c0-0.9-0.7-1.6-1.6-1.6h-1.6c-0.9,0-1.6,0.7-1.6,1.6v7.1H2.6C1.7,9.6,1,10.3,1,11.2v1.6c0,0.9,0.7,1.6,1.6,1.6h7.1v7.1c0,0.9,0.7,1.6,1.6,1.6h1.6c0.9,0,1.6-0.7,1.6-1.6v-7.1h7.1c0.9,0,1.6-0.7,1.6-1.6v-1.6C23,10.3,22.3,9.6,21.4,9.6z'/%3E%3C/svg%3E")` },
//                                 { label: 'Rhombus', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='black' stroke='none'%3E%3Cpath d='M12.7,2.3c-0.4-0.4-1.1-0.4-1.5,0l-8,9.1c-0.3,0.4-0.3,0.9,0,1.2l8,9.1c0.4,0.4,1.1,0.4,1.5,0l8-9.1c0.3-0.4,0.3-0.9,0-1.2L12.7,2.3z'/%3E%3C/svg%3E")` },
//                                 { label: 'Parallelogram', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 24 24' fill='black' stroke='none'%3E%3Cpolygon points='9.4,2 24,2 14.6,21.6 0,21.6'/%3E%3C/svg%3E")` },
//                                 { label: 'Rectangles', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' overflow='visible' height='100%' viewBox='0 0 60 30' fill='black' stroke='none'%3E%3Crect x='15' y='0' width='30' height='30'/%3E%3C/svg%3E")` },
//                                 { label: 'Dots', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 126 26' fill='black' stroke='none'%3E%3Cpath d='M3,10.2c2.6,0,2.6,2,2.6,3.2S4.4,16.5,3,16.5s-3-1.4-3-3.2S0.4,10.2,3,10.2z M18.8,10.2c1.7,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2c-1.7,0-3.2-1.4-3.2-3.2S17,10.2,18.8,10.2z M34.6,10.2c1.5,0,2.6,1.4,2.6,3.2s-0.5,3.2-1.9,3.2c-1.5,0-3.4-1.4-3.4-3.2S33.1,10.2,34.6,10.2z M50.5,10.2c1.7,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2c-1.7,0-3.3-0.9-3.3-2.6S48.7,10.2,50.5,10.2z M66.2,10.2c1.5,0,3.4,1.4,3.4,3.2s-1.9,3.2-3.4,3.2c-1.5,0-2.6-0.4-2.6-2.1S64.8,10.2,66.2,10.2z M82.2,10.2c1.7,0.8,2.6,1.4,2.6,3.2s-0.1,3.2-1.6,3.2c-1.5,0-3.7-1.4-3.7-3.2S80.5,9.4,82.2,10.2zM98.6,10.2c1.5,0,2.6,0.4,2.6,2.1s-1.2,4.2-2.6,4.2c-1.5,0-3.7-0.4-3.7-2.1S97.1,10.2,98.6,10.2z M113.4,10.2c1.2,0,2.2,0.9,2.2,3.2s-0.1,3.2-1.3,3.2s-3.1-1.4-3.1-3.2S112.2,10.2,113.4,10.2z'/%3E%3C/svg%3E")` },
//                                 { label: 'Fir Tree', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 126 26' fill='black' stroke='none'%3E%3Cpath d='M111.9,18.3v3.4H109v-3.4H111.9z M90.8,18.3v3.4H88v-3.4H90.8z M69.8,18.3v3.4h-2.9v-3.4H69.8z M48.8,18.3v3.4h-2.9v-3.4H48.8z M27.7,18.3v3.4h-2.9v-3.4H27.7z M6.7,18.3v3.4H3.8v-3.4H6.7z M46.4,4l4.3,4.8l-1.8,0l3.5,4.4l-2.2-0.1l3,3.3l-11,0.4l3.6-3.8l-2.9-0.1l3.1-4.2l-1.9,0L46.4,4z M111.4,4l2.4,4.8l-1.8,0l3.5,4.4l-2.5-0.1l3.3,3.3h-11l3.1-3.4l-2.5-0.1l3.1-4.2l-1.9,0L111.4,4z M89.9,4l2.9,4.8l-1.9,0l3.2,4.2l-2.5,0l3.5,3.5l-11-0.4l3-3.1l-2.4,0L88,8.8l-1.9,0L89.9,4z M68.6,4l3,4.4l-1.9,0.1l3.4,4.1l-2.7,0.1l3.8,3.7H63.8l2.9-3.6l-2.9,0.1L67,8.7l-2,0.1L68.6,4z M26.5,4l3,4.4l-1.9,0.1l3.7,4.7l-2.5-0.1l3.3,3.3H21l3.1-3.4l-2.5-0.1l3.2-4.3l-2,0.1L26.5,4z M4.9,4l3.7,4.8l-1.5,0l3.1,4.2L7.6,13l3.4,3.4H0l3-3.3l-2.3,0.1l3.5-4.4l-2.3,0L4.9,4z'/%3E%3C/svg%3E")` },
//                                 { label: 'Half Rounds', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 120 26' fill='black' stroke='none'%3E%3Cpath d='M11.9,15.9L11.9,15.9L0,16c-0.2-3.7,1.5-5.7,4.9-6C10,9.6,12.4,14.2,11.9,15.9zM26.9,15.9L26.9,15.9L15,16c0.5-3.7,2.5-5.7,5.9-6C26,9.6,27.4,14.2,26.9,15.9z M37.1,10c3.4,0.3,5.1,2.3,4.9,6H30.1C29.5,14.4,31.9,9.6,37.1,10z M57,15.9L57,15.9L45,16c0-3.4,1.6-5.4,4.9-5.9C54.8,9.3,57.4,14.2,57,15.9z M71.9,15.9L71.9,15.9L60,16c-0.2-3.7,1.5-5.7,4.9-6C70,9.6,72.4,14.2,71.9,15.9z M82.2,10c3.4,0.3,5,2.3,4.8,6H75.3C74,13,77.1,9.6,82.2,10zM101.9,15.9L101.9,15.9L90,16c-0.2-3.7,1.5-5.7,4.9-6C100,9.6,102.4,14.2,101.9,15.9z M112.1,10.1c2.7,0.5,4.3,2.5,4.9,5.9h-11.9l0,0C104.5,14.4,108,9.3,112.1,10.1z'/%3E%3C/svg%3E")` },
//                                 { label: 'Leaves', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 117 26' fill='black' stroke='none'%3E%3Cpath d='M3,1.5C5,4.9,6,8.8,6,13s-1.7,8.1-5,11.5C0.3,21.1,0,17.2,0,13S1,4.9,3,1.5z M16,1.5c2,3.4,3,7.3,3,11.5s-1,8.1-3,11.5c-2-4.1-3-8.3-3-12.5S14,4.3,16,1.5z M29,1.5c2,4.8,3,9.3,3,13.5s-1,7.4-3,9.5c-2-3.4-3-7.3-3-11.5S27,4.9,29,1.5z M41.1,1.5C43.7,4.9,45,8.8,45,13s-1,8.1-3,11.5c-2-3.4-3-7.3-3-11.5S39.7,4.9,41.1,1.5zM55,1.5c2,2.8,3,6.3,3,10.5s-1.3,8.4-4,12.5c-1.3-3.4-2-7.3-2-11.5S53,4.9,55,1.5z M68,1.5c2,3.4,3,7.3,3,11.5s-0.7,8.1-2,11.5c-2.7-4.8-4-9.3-4-13.5S66,3.6,68,1.5z M82,1.5c1.3,4.8,2,9.3,2,13.5s-1,7.4-3,9.5c-2-3.4-3-7.3-3-11.5S79.3,4.9,82,1.5z M94,1.5c2,3.4,3,7.3,3,11.5s-1.3,8.1-4,11.5c-1.3-1.4-2-4.3-2-8.5S92,6.9,94,1.5z M107,1.5c2,2.1,3,5.3,3,9.5s-0.7,8.7-2,13.5c-2.7-3.4-4-7.3-4-11.5S105,4.9,107,1.5z'/%3E%3C/svg%3E")` },
//                                 { label: 'Stripes', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 120 26' fill='black' stroke='none'%3E%3Cpath d='M54,1.6V26h-9V2.5L54,1.6z M69,1.6v23.3L60,26V1.6H69z M24,1.6v23.5l-9-0.6V1.6H24z M30,0l9,0.7v24.5h-9V0z M9,2.5v22H0V3.7L9,2.5z M75,1.6l9,0.9v22h-9V1.6z M99,2.7v21.7h-9V3.8L99,2.7z M114,3.8v20.7l-9-0.5V3.8L114,3.8z'/%3E%3C/svg%3E")` },
//                                 { label: 'Squares', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 126 26' fill='black' stroke='none'%3E%3Cpath d='M46.8,7.8v11.5L36,18.6V7.8H46.8z M82.4,7.8L84,18.6l-12,0.7L70.4,7.8H82.4z M0,7.8l12,0.9v9.9H1.3L0,7.8z M30,7.8v10.8H19L18,7.8H30z M63.7,7.8L66,18.6H54V9.5L63.7,7.8z M89.8,7L102,7.8v10.8H91.2L89.8,7zM108,7.8l12,0.9v8.9l-12,1V7.8z'/%3E%3C/svg%3E")` },
//                                 { label: 'Trees', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 123 26' fill='black' stroke='none'%3E%3Cpath d='M6.4,2l4.2,5.7H7.7v2.7l3.8,5.2l-3.8,0v7.8H4.8v-7.8H0l4.8-5.2V7.7H1.1L6.4,2z M25.6,2L31,7.7h-3.7v2.7l4.8,5.2h-4.8v7.8h-2.8v-7.8l-3.8,0l3.8-5.2V7.7h-2.9L25.6,2z M47.5,2l4.2,5.7h-3.3v2.7l3.8,5.2l-3.8,0l0.4,7.8h-2.8v-7.8H41l4.8-5.2V7.7h-3.7L47.5,2z M66.2,2l5.4,5.7h-3.7v2.7l4.8,5.2h-4.8v7.8H65v-7.8l-3.8,0l3.8-5.2V7.7h-2.9L66.2,2zM87.4,2l4.8,5.7h-2.9v3.1l3.8,4.8l-3.8,0v7.8h-2.8v-7.8h-4.8l4.8-4.8V7.7h-3.7L87.4,2z M107.3,2l5.4,5.7h-3.7v2.7l4.8,5.2h-4.8v7.8H106v-7.8l-3.8,0l3.8-5.2V7.7h-2.9L107.3,2z'/%3E%3C/svg%3E")` },
//                                 { label: 'Tribal', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 121 26' fill='black' stroke='none'%3E%3Cpath d='M29.6,10.3l2.1,2.2l-3.6,3.3h7v2.9h-7l3.6,3.5l-2.1,1.7l-5.2-5.2h-5.8v-2.9h5.8L29.6,10.3z M70.9,9.6l2.1,1.7l-3.6,3.5h7v2.9h-7l3.6,3.3l-2.1,2.2l-5.2-5.5h-5.8v-2.9h5.8L70.9,9.6z M111.5,9.6l2.1,1.7l-3.6,3.5h7v2.9h-7l3.6,3.3l-2.1,2.2l-5.2-5.5h-5.8v-2.9h5.8L111.5,9.6z M50.2,2.7l2.1,1.7l-3.6,3.5h7v2.9h-7l3.6,3.3l-2.1,2.2L45,10.7h-5.8V7.9H45L50.2,2.7z M11,2l2.1,1.7L9.6,7.2h7V10h-7l3.6,3.3L11,15.5L5.8,10H0V7.2h5.8L11,2z M91.5,2l2.1,2.2l-3.6,3.3h7v2.9h-7l3.6,3.5l-2.1,1.7l-5.2-5.2h-5.8V7.5h5.8L91.5,2z'/%3E%3C/svg%3E")` },
//                                 { label: 'X', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 126 26' fill='black' stroke='none'%3E%3Cpath d='M10.7,6l2.5,2.6l-4,4.3l4,5.4l-2.5,1.9l-4.5-5.2l-3.9,4.2L0.7,17L4,13.1L0,8.6l2.3-1.3l3.9,3.9L10.7,6z M23.9,6.6l4.2,4.5L32,7.2l2.3,1.3l-4,4.5l3.2,3.9L32,19.1l-3.9-3.3l-4.5,4.3l-2.5-1.9l4.4-5.1l-4.2-3.9L23.9,6.6zM73.5,6L76,8.6l-4,4.3l4,5.4l-2.5,1.9l-4.5-5.2l-3.9,4.2L63.5,17l4.1-4.7L63.5,8l2.3-1.3l4.1,3.6L73.5,6z M94,6l2.5,2.6l-4,4.3l4,5.4L94,20.1l-3.9-5l-3.9,4.2L84,17l3.2-3.9L84,8.6l2.3-1.3l3.2,3.9L94,6z M106.9,6l4.5,5.1l3.9-3.9l2.3,1.3l-4,4.5l3.2,3.9l-1.6,2.1l-3.9-4.2l-4.5,5.2l-2.5-1.9l4-5.4l-4-4.3L106.9,6z M53.1,6l2.5,2.6l-4,4.3l4,4.6l-2.5,1.9l-4.5-4.5l-3.5,4.5L43.1,17l3.2-3.9l-4-4.5l2.3-1.3l3.9,3.9L53.1,6z'/%3E%3C/svg%3E")` },
//                                 { label: 'Zigzag Curve', value: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' overflow='visible' height='100%' viewBox='0 0 120 26' fill='black' stroke='none'%3E%3Cpolygon points='0,14.4 0,21 11.5,12.4 21.3,20 30.4,11.1 40.3,20 51,12.4 60.6,20 69.6,11.1 79.3,20 90.1,12.4 99.6,20 109.7,11.1 120,21 120,14.4 109.7,5 99.6,13 90.1,5 79.3,14.5 71,5.7 60.6,12.4 51,5 40.3,14.5 31.1,5 21.3,13 11.5,5 	'/%3E%3C/svg%3E")` },

//                             ]}

//                             onChange={(new_val) => {
//                                 props.setAttributes({ seprator_divider_style: new_val })
//                                 // seprator_divider();
//                                 seperator_divider_1();
//                             }}
//                             value={props.attributes.seprator_divider_style}
//                         />
//                         <PanelRow>
//                             <p>Container Width</p>

//                             <div>
//                                 <Button className="seprator_width_per" onClick={seprator_width_per} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>%</Button>
//                                 <Button className="seprator_width_px" onClick={seprator_width_px} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
//                             </div>
//                         </PanelRow>

//                         <RangeControl

//                             min={0}
//                             max={props.attributes.max_range}
//                             step={0.1}
//                             initialPosition={100}
//                             value={props.attributes.seprator_width}
//                             onChange={(new_val) => {
//                                 props.setAttributes({ seprator_width: new_val })
//                                 seperator_width_scss();
//                             }}
//                         />

//                         {/* For alignment  */}

//                         <PanelRow>
//                             <div><p>Alingment</p></div>
//                             <div>
//                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignLeft} icon='editor-alignleft' />
//                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignCenter} icon='editor-aligncenter' />
//                                 <Dashicon style={{ cursor: 'pointer' }} onClick={alignRight} icon='editor-alignright' />
//                             </div>
//                         </PanelRow>

//                         <hr />
//                         {/* end of alignment  */}



//                         {/* Add element  */}
//                         <PanelRow>
//                             <div><p>Add Element</p></div>
//                             <div>
//                                 <Button style={{ border: "1px solid black", padding: "7px 9px", height: "29px" }} onClick={element_none}><i class="eicon-ban" aria-hidden="true"></i></Button>
//                                 <Button style={{ border: "1px solid black", padding: "7px 9px", height: "29px" }} onClick={element_text}><i class="eicon-t-letter-bold" aria-hidden="true"></i></Button>
//                                 <Button style={{ border: "1px solid black", padding: "7px 9px", height: "29px" }} onClick={element_icon}><span className={props.attributes.icon_selector}></span></Button>


//                             </div>
//                         </PanelRow>
//                         <br />
//                         <div className="bb_element_text" style={{ display: props.attributes.element_content }}>
//                             <div className="bb_element_text" style={{ display: props.attributes.element_text_content }}>
//                                 <PanelRow>
//                                     <div><p>Text</p></div>
//                                     <div>
//                                         <TextControl
//                                             value={props.attributes.text_divider}
//                                             onChange={(new_val) => {
//                                                 props.setAttributes({ text_divider: new_val })
//                                             }}
//                                         />

//                                     </div>
//                                 </PanelRow>
//                                 <PanelRow>
//                                     <div><p>Html Tag</p></div>
//                                     <div>
//                                         <SelectControl
//                                             options={[
//                                                 { label: 'H1', value: 'h1' },
//                                                 { label: 'H2', value: 'h2' },
//                                                 { label: 'H3', value: 'h3' },
//                                                 { label: 'H4', value: 'h4' },
//                                                 { label: 'H5', value: 'h5' },
//                                                 { label: 'H6', value: 'h6' },
//                                                 { label: 'div', value: 'div' },
//                                                 { label: 'span', value: 'span' },
//                                                 { label: 'p', value: 'p' },
//                                             ]}
//                                             value={props.attributes.text_divider_headings}
//                                             onChange={(new_val) => {
//                                                 props.setAttributes({ text_divider_headings: new_val })
//                                             }}
//                                         />
//                                     </div>
//                                 </PanelRow>
//                             </div>
//                             <div className="bb_element_text" style={{ display: props.attributes.element_icon_content }}>
//                                 <IconPicker
//                                     allowReset={false}
//                                     value={props.attributes.icon_selector}
//                                     onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
//                                 />
//                             </div>
//                         </div>
//                     </PanelBody>


//                     <PanelBody title={__("Style")} initialOpen={false}>

//                         {/* Divider width  */}

//                         <RangeControl
//                             label="Size"
//                             min={0}
//                             max={8}
//                             step={0.1}
//                             initialPosition={2.2}
//                             value={props.attributes.divider_width}
//                             onChange={(new_val) => {
//                                 props.setAttributes({ divider_width: new_val })
//                             }}
//                         />


//                         {/* End of the divider width  */}


//                         {/* Divider Width Style */}

//                         <RangeControl
//                             label="Divider Container Width"
//                             min={0}
//                             max={100}
//                             step={1}
//                             initialPosition={10}
//                             value={props.attributes.divider_size_width}
//                             onChange={(new_val) => {
//                                 props.setAttributes({ divider_size_width: new_val })
//                                 seperator_width_scss();
//                             }}
//                         />


//                         {/* End of the divider width  */}


//                     </PanelBody>
//                 </InspectorControls>
//                 <div class={props.className} style={styles.bb_spacer_wrapper}>
//                     <div class="bb-widget-container" style={styles.bb_spacer}>
//                         <RichText
//                             tagName={props.attributes.text_divider_headings}
//                             value={props.attributes.text_divider}
//                             onChange={(new_val) => {
//                                 props.setAttributes({ text_divider: new_val })
//                             }}
//                             style={styles.bb_spacer_container}
//                         />
//                     </div>


//                 </div>
//             </React.Fragment>
//         ]
//     },

//     save: (props) => {
//         return (null)
//     }
// });


